import React, { useEffect, useRef, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const Profile = () => {
  let history = useHistory();
  const [profileData, setProfileData] = useState({ regid: '', dob: '', fname: '', lname: '', pan: '', mobile: '', email: '', address: '', pincode: '', city: '', state: '' });
  const [editname, seteditname] = useState(false);
  const didMountRef = useRef(true);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [fname, setfname] = useState('');
  const [lname, setlname] = useState('');
  const [step, setstep] = useState(1);
  const [UserBankApprove, setUserBankApprove] = useState(0);
  const [Password, setPassword] = useState('');
  const [ConfirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [UserBankData, SetUserBankData] = useState({});
  useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      const dataString = {
      }
      apiServices.getUserData(dataString).then(result => {
        if (result.data.status == 'success') {
          setUserBankApprove(result.data.gs_epayezz_bankapprove)
          var cityname = '';
          var statename = '';
          if (result.data.data.city != null) {
            cityname = result.data.data.city.cities_name;
          }
          if (result.data.data.stste != null) {
            statename = result.data.data.state.state_name;
          }
          setProfileData({
            fname: result.data.data.gs_fname,
            lname: result.data.data.gs_lname,
            dob: result.data.data.gs_dob,
            pan: result.data.data.gs_pan_no,
            mobile: result.data.data.gs_mobile,
            email: result.data.data.gs_email,
            regid: result.data.data.gs_registration_id,
            address: result.data.data.gs_address1,
            pincode: result.data.data.gs_pin,
            city: cityname,
            state: statename,
          });
          setSpinnerLoading(false);
        }
        else if (result.data.status == "error" && result.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(result.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(result.data.message)
          setSpinnerLoading(false)
          return false
        }
      })
    }
    didMountRef.current = false;
  }, [])
  const changePassword = (e) => {
    if (Password === '' || Password === undefined) {
      setErrorMessage('Password Field Is Required');
      return false;
    }
    if (ConfirmPassword === '' || ConfirmPassword === undefined) {
      setErrorMessage('Confirm Password Field Is Required');
      return false;
    }
    if (Password != ConfirmPassword) {
      setErrorMessage('Password & Confirm Password Should Be Same');
      return false;
    }
    const dataString = {
      "password": Password,
    }
    apiServices.changepassword(dataString).then(result => {
      if (result.data.status == 'success') {
        alert('Password Changed Successfully');
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message)
        setSpinnerLoading(false)
      }
    })
  }
  const getusrbanks = () => {
    setstep(4);
    const dataString = {
    }
    apiServices.getusercanbankdata(dataString).then(res => {
      if (res.data.status == 'success') {
        SetUserBankData(res.data.data)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
        return false
      }
    }
    )
  }
  const logout = () => {
    const dataString = {
   }
    if (window.confirm("Are You Sure You Want To Logout ?") == true) {
      apiServices.logoutPostRequest(dataString).then(res => {
        if (res.data.status == "success") {
        //  localStorage.removeItem('user');
          localStorage.removeItem('AUTH_TOKEN');
          history.push("/login");
        }
      })
    }
  }
  return (
    <div>
      <Header />
      <Helmet>
        <title>Profile - Goalstox</title>
        {/* <meta name="keywords" content={pageKeywords}/>  */}
        {/* <meta name="description" content={pageDescription} /> */}
      </Helmet>
      <section>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-3'>
              <div className='user-avtar'>
                <div className="user-avtar-img">
                  <img src="img/user.png"></img>
                </div>
                <div className="user-avtar-content mg-l-15">
                  <h6 className="tx-white fw600 mb-0">Hi! {profileData.fname} {profileData.lname}</h6>
                  <p className="mb-0 tx-white tx-13" > {profileData.regid}</p>
                </div>
              </div>
              <div className='sidelist'>
                <ul>
                  <li onClick={(e) => { setstep(1) }} className='active'><a href="#">My Profile <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i></a></li>
                  {/* <li onClick={(e) => {setstep(2)}}><a href="#">My Orders <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i></a></li> */}
                  <li onClick={(e) => { setstep(3) }}><a href="#">Change Password <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i></a></li>
                  {UserBankApprove == 1 ?
                    <li onClick={getusrbanks}><a href="#">ePayEezz <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i></a></li>
                    : ''}
                  <li onClick={logout}><a href="#">Logout <i className="fa fa-angle-right ml-auto" aria-hidden="true"></i></a></li>
                </ul>
              </div>
            </div>
            <div className='col-lg-9'>
              {step == 1 ?
                <>
                  <div className='mpanel mg-b-15'>
                    <div className='mpanel-header'><h5 className='mg-b-0 fw600'>Personal Information</h5>
                      {/* <span className='ml-auto tx-theme fw600'>Edit</span> */}
                    </div>
                    <div className='mpanel-body'>
                      <div className='profiled-list'>
                        <ul>
                          {/* {editname == true?
                         <li><span className='mg-b-10'>Name:</span><div class="newsletter mg-t-10"><input type="text" value={profileData.fname} onChange={(e) => {setfname(e.target.value)}}/><input type="text" value={profileData.lname} onChange={(e) => {setlname(e.target.value)}}/><button  onClick={saveeditname} class="btn btn-primary newsletter-button">Save</button></div></li>
                        :
                        <li><span>Name:</span>{profileData.fname} {profileData.lname}<i onClick={seteditname(true)} className="fa fa-pencil-square-o mg-l-10" aria-hidden="true"></i></li>
                        } */}
                          <li><span>Name:</span>{profileData.fname} {profileData.lname}</li>
                          <li><span>Email Id:</span>{profileData.email}</li>
                          <li><span>Phone Number:</span>{profileData.mobile}</li>
                          <li><span>Date of Birth:</span>{profileData.dob}</li>
                          <li><span>Pan Number:</span> {profileData.pan}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className='mpanel'>
                    <div className='mpanel-header'><h5 className='mg-b-0 fw600'>Address Information</h5>
                      {/* <span className='ml-auto tx-theme fw600'>Edit</span> */}
                    </div>
                    <div className='mpanel-body'>
                      <div className='profiled-list'>
                        <ul>
                          <li><span>Address:</span>{profileData.address}</li>
                          <li><span>City:</span>{profileData.city}</li>
                          <li><span>State:</span>{profileData.state}</li>
                          <li><span>Pincode:</span>{profileData.pincode}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
                : ''
              }
              {/* {step == 2?
                  <div className='mpanel mg-b-15'>
                  <div className='mpanel-header'><h5 className='mg-b-0 fw600'>My Orders</h5>
                  </div>
                  <div className='mpanel-body'>
                    <div className='profiled-list'>
                    No Orders Found !! 
                    </div>
                   </div>
                 </div>:''
                  } */}
              {step == 3 ?
                <div className='mpanel mg-b-15'>
                  <div className='mpanel-header'><h5 className='mg-b-0 fw600'>Change Password</h5>
                  </div>
                  <div className='mpanel-body ecan-form'>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className='ecan-form-group'>
                          <label>Password<span style={{ color: '#ff0000' }}>*</span></label>
                          <input onChange={(e) => { setPassword(e.target.value) }} type="password"></input>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label>Confirm Password<span style={{ color: '#ff0000' }}>*</span></label>
                        <input onChange={(e) => { setConfirmPassword(e.target.value) }} type="password"></input>
                      </div>
                    </div>
                    {
                    errorMessage != '' ?
                        <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                    }
                    <button onClick={changePassword} class="btn btn-primary newsletter-button">Change Password</button>
                  </div>
                </div> : ''
              }
              {step == 4 ?
                <div className='mpanel mg-b-15'>
                  <div className='mpanel-header'><h5 className='mg-b-0 fw600'>ePayEezz Registration Status</h5>
                  </div>
                  <div className='mpanel-body ecan-form'>
                    <div className="row">
                      {UserBankData.crb_bank1_mandate_res != null ?
                        <div className="col-lg-6">
                          <div className='ecan-form-group'>
                            <h6>{UserBankData.crb_bank1}</h6>
                            <h6>{UserBankData.crb_bank_acc_no1 != null ? UserBankData.crb_bank_acc_no1.replace(/.(?=.{4})/g, 'X') : ""}</h6>
                            <h6>{UserBankData.crb_bank_ifsc1}</h6>
                          </div>
                        </div> : ''
                      }
                      {UserBankData.crb_bank2_mandate_res != null ?
                        <div className="col-lg-6">
                          <div className='ecan-form-group'>
                            <h6>{UserBankData.crb_bank2}</h6>
                            <h6>{UserBankData.crb_bank_acc_no1 != null ? UserBankData.crb_bank_acc_no2.replace(/.(?=.{4})/g, 'X') : ""}</h6>
                            <h6>{UserBankData.crb_bank_ifsc2}</h6>
                          </div>
                        </div> : ''
                      }
                      {UserBankData.crb_bank3_mandate_res != null ?
                        <div className="col-lg-6">
                          <div className='ecan-form-group'>
                            <h6>{UserBankData.crb_bank3}</h6>
                            <h6>{UserBankData.crb_bank_acc_no1 != null ? UserBankData.crb_bank_acc_no3.replace(/.(?=.{4})/g, 'X') : ""}</h6>
                            <h6>{UserBankData.crb_bank_ifsc3}</h6>
                          </div>
                        </div> : ''
                      }
                    </div>
                    {
                      errorMessage != '' ?
                        <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                    }
                    <Link to="/epayezzregistration" class="mg-t-20 buttonab-line-3">Register For Other ePayEezz <i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                  </div>
                </div> : ''
              }
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default Profile;